export default __webpack_public_path__ + "static/media/Cruelty Free.f277ffc2.svg";